/*global AmCharts, App */

Components.Energy.Manager.PredictionChart = function(container, loadDataLink, currencySymbol ,predictionEvents) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var prepareDataForChart = function(rawData) {
        var chartData = [];

        var consumptionData = rawData.records;
        for (var index in consumptionData) {
            var row = consumptionData[index];
            var record = {};
            if (row.integratedConsumption) {
                record.integratedConsumption = Math.round(row.integratedConsumption * 100) / 100;
            }
            if (row.previousPeriodIntegratedConsumption) {
                record.previousPeriodIntegratedConsumption = Math.round(row.previousPeriodIntegratedConsumption * 100) / 100;
            }
            if (row.advancePayments) {
                record.advancePayments = Math.round(row.advancePayments * 100) / 100;
            }

            if(row.predicitons) {
                for (var index in predictionEvents) {
                    if (row.predicitons[index]) {
                        var predictionRow = row.predicitons[index];
                        if (predictionRow.integratedConsumption) {
                            record["prediction-" + index + "-integratedConsumption"] = Math.round(predictionRow.integratedConsumption * 100) / 100;
                        }
                    }
                }
            }

            record.date = new Date(row.timestamp * 1000);
            chartData.push(record);
        }

        var endValue = rawData.endValue
        for (var index in endValue) {
            let item = document.querySelector("#endValues-" + index + ".prediction__amounts__item > span");
            if (!item) continue;
            item.innerText = endValue[index];
        }


        var events = [];
        for (let i in predictionEvents) {
            let ev = predictionEvents[i];
            if (!ev.flag) continue;
            let date = new Date(ev.dateTimeFormatC);
            date.setTime(date.getTime() - (12 * 60 * 60 * 1000));
            events.push({
                date: date,
                type: "flag",
                color: "#ff7bad",
                backgroundColor: "#ff7bad",
                borderColor: "#ff7bad",
                rollOverColor: "#ff7bad",
                graph: "prediction-" + i + "-integratedConsumption",
                fontSize: 16,
                text: "i",
            });
        }

        var guide = new AmCharts.Guide();
        guide.date = (new Date()).setHours(12, 0, 0);
        guide.color = "#aaa";
        guide.fontSize = 15;
        guide.label = "DNES";
        guide.lineAlpha = 1;
        guide.lineColor = "#aaa";
        guide.lineThickness = 2;

        if (chartData.length == 0) {
            _chart.clear();
        } else {
            _chart.dataSets[0].dataProvider = chartData;
            _chart.dataSets[0].stockEvents = events;
            _chart.validateData();
            _chart.panels[0].categoryAxis.addGuide(guide);
        }
    };

    var loadData = function() {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function() {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function(result) {
                if (result === null || result.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    if (result.typeOfInterval) {
                        if (result.typeOfInterval === "1-hour") {
                            _chart.categoryAxesSettings.minPeriod = "hh";
                        } else if (result.typeOfInterval === "15-min") {
                            _chart.categoryAxesSettings.minPeriod = "15mm";
                        } else {
                            _chart.categoryAxesSettings.minPeriod = "5mm";
                        }
                    }
                    prepareDataForChart(result);
                }
            },
            error: function() {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var createChart = function() {
        _chart = new AmCharts.AmStockChart();
        _chart.colors = [App.Ui.getColors()[3]];
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;

        var fieldMappings = [
            {
                fromField: "integratedConsumption",
                toField: "integratedConsumption"
            },
            {
                fromField: "previousPeriodIntegratedConsumption",
                toField: "previousPeriodIntegratedConsumption"
            },
            {
                fromField: "advancePayments",
                toField: "advancePayments"
            }
        ];

        for (var index in predictionEvents) {
            fieldMappings.push({
                fromField: "prediction-" + index + "-integratedConsumption",
                toField: "prediction-" + index + "-integratedConsumption"
            });
        }

        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: fieldMappings
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.autoMarginOffset = 50;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.colors = _chart.colors;
        stockPanel.addListener("clickGraphItem", function (event) {
            let item = event.item;
            if (!item.bulletConfig) return;
            let id = event.target.id;

            let panel = document.querySelector("#" + id);
            if (!panel) return;

            let x = item.x;
            if (x < 280) x = 280;

            panel.style.top = (item.y - 210) + "px";
            panel.style.left = (x - 250) + "px";
            panel.style.display = "block";
        });
        _chart.addPanel(stockPanel);

        var graphA = new AmCharts.StockGraph();
        graphA.id = "sg1";
        graphA.valueField = "integratedConsumption";
        graphA.periodValue = "High";
        graphA.type = "line";
        graphA.lineThickness = 4;
        graphA.lineColor = "#aed685";
        graphA.bulletField  = "bullet";
        graphA.balloonText = "Spotřeba: <b>[[value]]" + currencySymbol + "</b>";
        graphA.useDataSetColors = false;
        stockPanel.addStockGraph(graphA);

        var graphB = new AmCharts.StockGraph();
        graphB.id = "sg2";
        graphB.valueField = "previousPeriodIntegratedConsumption";
        graphB.periodValue = "High";
        graphB.type = "line";
        graphB.lineThickness = 2;
        graphB.lineColor = "#c9b39a";
        graphB.bullet = "square";
        graphB.balloonText = "Předchozí spotřeba: <b>[[value]]" + currencySymbol + "</b>";
        graphB.useDataSetColors = false;
        stockPanel.addStockGraph(graphB);

        var graphC = new AmCharts.StockGraph();
        graphC.id = "sg3";
        graphC.valueField = "advancePayments";
        graphC.periodValue = "High";
        graphC.type = "line";
        graphC.lineThickness = 1;
        graphC.lineColor = "#24ace3";
        graphC.fillAlphas = 0.5;
        graphC.bullet = "square";
        graphC.balloonText = "Zálohy: <b>[[value]]" + currencySymbol + "</b>";
        graphC.useDataSetColors = false;
        stockPanel.addStockGraph(graphC);

        for (var index in predictionEvents) {
            var graphPredictionA = new AmCharts.StockGraph();
            graphPredictionA.id = "prediction-" + index + "-integratedConsumption";
            graphPredictionA.valueField = "prediction-" + index + "-integratedConsumption";
            graphPredictionA.periodValue = "High";
            graphPredictionA.type = "line";
            graphPredictionA.lineColor = "#ff7bad";
            graphPredictionA.lineThickness = 2;
            graphPredictionA.bulletField  = "bullet";
            if (!predictionEvents[index]["flag"]) {
                graphPredictionA.lineColor = "#000000";
                graphPredictionA.lineThickness = 4;
                graphPredictionA.dashLength = 8;
            }
            graphPredictionA.balloonText = predictionEvents[index]["title"] + ": <b>[[value]] " + currencySymbol + "</b>";
            graphPredictionA.useDataSetColors = false;
            stockPanel.addStockGraph(graphPredictionA);
        }

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.enabled = false;
        scrollbarSettings.graph = "sg1";
        scrollbarSettings.graphType = "step";
        scrollbarSettings.updateOnReleaseOnly = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.categoryBalloonDateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'hh',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'DD',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'WW',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'MM',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = true;
        cursorSettings.valueLineEnabled = true;
        cursorSettings.valueLineBalloonEnabled = true;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["5mm", "15mm", "hh", "6hh", "12hh", "DD", "MM", "YYYY"];
        categoryAxesSettings.minPeriod = "5mm";
        categoryAxesSettings.maxSeries = 370;
        categoryAxesSettings.dateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN'
            },
            {
                period: 'hh',
                format: 'JJ:NN'
            },
            {
                period: 'DD',
                format: 'DD.MM.'
            },
            {
                period: 'WW',
                format: 'DD.MM.'
            },
            {
                period: 'MM',
                format: 'DD.MM.'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        _chart.categoryAxesSettings = categoryAxesSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        valueAxesSettings.unit = currencySymbol;
        _chart.valueAxesSettings = valueAxesSettings;

        _chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        _chart.addListener("dataUpdated", function () {
            let items = [];
            for (let i in _chart.panels[0].stockGraphs) {
                let graph = _chart.panels[0].stockGraphs[i];
                if (!graph.lastDataItem || !graph.valueField) continue;
                if (!(graph.lastDataItem.y >= 0)) continue;
                let top = graph.lastDataItem.y - 20;
                let item = document.querySelector("#endValues-" + graph.valueField + ".prediction__amounts__item");
                if (!item) continue;
                top =  Math.round(top);
                item.style.top = top + "px";
                item.style.display = "block";
                items.push(item);
            }
            items.sort(function (a,b) {
              return (a.getBoundingClientRect().top > b.getBoundingClientRect().top) ? 1 : ((b.getBoundingClientRect().top > a.getBoundingClientRect().top) ? -1 : 0);
            });
            let offset = 0;
            for(let index in items) {
                if (index == 0)offset = items[index].parentElement.getBoundingClientRect().top;
                if (index > 0) {
                    if (items[index].getBoundingClientRect().top < items[index - 1].getBoundingClientRect().bottom) {
                        let top = (items[index-1].getBoundingClientRect().bottom) - offset;
                        items[index].style.top = top + "px";
                        items[index].style.display = "block";
                    }
                }
            }



        });

        let closePanels = function() {
            let panels = document.querySelectorAll(".prediction__modals .panel");
            for (let i in panels) {
                panels[i].style.display = "none";
            }
        };
        _chart.addListener("zoomed", closePanels);
        window.addEventListener("resize", closePanels);

        _chart.write(container);
        loadData();
    };


    /* public */
    /* contructor */
    createChart();

};
